import type React from 'react';
import { classNames, cva } from '@/lib/utils';
import type { ActionButtonProps } from './ActionButton.types';

const actionButtonVariants = cva(
  // Base styles
  'inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md text-sm font-medium cursor-pointer transition-all duration-200 ease-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none',
  {
    variants: {
      variant: {
        primary:
          'bg-gradient-to-r from-panel-primary-500/20 to-panel-primary-600/20 text-panel-primary-200 border border-panel-primary-500/40 hover:from-panel-primary-500/30 hover:to-panel-primary-600/30 hover:border-panel-primary-400/60 hover:shadow-lg hover:shadow-panel-primary-500/10 active:scale-[0.98]',
        secondary:
          'bg-white/[0.04] text-gray-300 border border-white/10 hover:bg-white/[0.08] hover:text-white hover:border-white/20 active:scale-[0.98]',
        view: 'bg-blue-500/10 text-blue-400 border border-blue-500/30 hover:bg-blue-500/20 hover:border-blue-400/50 active:scale-[0.98]',
        back: 'bg-white/[0.04] text-gray-300 border border-white/10 hover:bg-white/[0.08] hover:text-white hover:border-white/20 active:scale-[0.98]',
        danger:
          'bg-red-500/10 text-red-400 border border-red-500/30 hover:bg-red-500/20 hover:border-red-400/50 active:scale-[0.98]',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  children,
  icon,
  variant = 'primary',
  disabled = false,
  className = '',
  type = 'button',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(actionButtonVariants({ variant }), className)}
      disabled={disabled}
    >
      {icon && <img src={icon} alt="" className="w-3.5 h-3.5" loading="lazy" />}
      {children}
    </button>
  );
};
